var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisaibleCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6365 2.50012H8.60556C7.501 2.50012 6.60556 3.39555 6.60556 4.50012V12.1359C6.60556 13.2405 7.501 14.1359 8.60557 14.1359H14.6673C15.7719 14.1359 16.6673 13.2405 16.6673 12.1359V7.53095M11.6365 2.50012L16.6673 7.53095M11.6365 2.50012V5.53095C11.6365 6.63552 12.5319 7.53095 13.6365 7.53095H16.6673M6.25654 5.8952H5.33399C4.22942 5.8952 3.33398 6.79063 3.33398 7.8952V15.5001C3.33398 16.6047 4.22941 17.5001 5.33398 17.5001H11.334C12.4385 17.5001 13.334 16.6047 13.334 15.5001V14.568",
    stroke: "#C2C4C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisaibleCopy);
export default __webpack_public_path__ + "static/media/disaible-copy.cf05d7b0d423f4a73c7f014c668c773c.svg";
export { ForwardRef as ReactComponent };